'use strict';

var processInclude = require('base/util');
processInclude(require('./pdp'));
processInclude(require('./orderDetail'));
processInclude(require('./trackOrder'));
